/**
 * All services state definitions
 */

import * as Activity from './activity/state';
import * as Form from './form/state';
import * as App from './app/state';
import * as Map from './map/state';

const $state = {
  Activity,
  Form,
  App,
  Map,
};

export default $state;
